var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1658_16857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5052 18.8841C19.2761 16.0408 20.7052 11.2788 21.0161 8.82564L14.3234 4.37358L12.3761 3.07485C12.3018 3.02636 12.2145 3.00049 12.1252 3.00049C12.0359 3.00049 11.9486 3.02636 11.8743 3.07485L2.9834 8.77754C3.04885 13.8977 6.87796 19.6377 11.8416 22.0161C11.9022 22.0438 11.9683 22.0582 12.0352 22.0582C12.1021 22.0582 12.1682 22.0438 12.2288 22.0161C13.8484 21.2473 15.3007 20.1782 16.5052 18.8681",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1658_16857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 19.0588,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.5fb8587754f71853a422073c6b12b729.svg";
export { ForwardRef as ReactComponent };